/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_HomerInputs */

const cs_enum_homer = /** @type {(inputs: Enum_HomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homer`)
};

const en_enum_homer = /** @type {(inputs: Enum_HomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homer`)
};

/**
* | output |
* | --- |
* | "Homer" |
*
* @param {Enum_HomerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_homer = /** @type {((inputs?: Enum_HomerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_HomerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_homer(inputs)
	return cs_enum_homer(inputs)
});